module.exports =
  '_GOAL_SETTINGS':
    'TITLE': 'Goal Settings'
    'ALL_USERS_AVG_DATA': "All User's Avg. Data"
    'VALUE_OF_YOUR_GOAL': 'Value of Your Goal'
    'AVG_SCORE': 'Avg. Score'
    'AVG_PUTTS': 'Avg. Putts (per 1 hole)'
    'FAIRWAY_HIT': 'Fairway hit (%)'
    'GIR': 'GIR (%)'
    'BOGEY_ON': 'GIR+1 (%)'
    'MY_DATA': 'My Data (Entire Period)'



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/goal-settings/i18n/en.coffee